import React, {useEffect} from 'react';
import {useHistory, useLocation, useParams} from 'react-router-dom';
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {getInsiderProgramService} from "../../../services/learning_programs.service";
import {isClientWorkspace} from "../../../utils/capabilities";
import {useAuth} from "../../../context/auth";

/** Where a built program opens. Use this instead of the program dashboard. */
export const getProgramPreviewPath = (code) => `/dq_pro/products/program/${code}/preview`;

/*
 * Opening a program used to land on its dashboard (Outline / Your Program /
 * Resources cards) and needed one more click to reach the preview. That step is
 * skipped: every link now comes here, which opens the preview straight away.
 * The dashboard page itself is kept, just no longer linked.
 *
 * The preview has no :code in its route, so the program is handed over in
 * router state — the same state the dashboard's Preview button used to pass.
 */
const DQProProgPreviewRedirectPage = () => {
    const history = useHistory();
    const location = useLocation();
    const { code } = useParams();
    const { authUser } = useAuth();

    useEffect(() => {
        let cancelled = false;

        const open = async () => {
            /*
             * A school / network viewing a program its partner built can only view
             * it (SW-46 / SNW-64) — the dashboard's isPartnerProgramForClient rule.
             * Only a client workspace needs the program's creator to decide that.
             */
            let viewOnly = false;
            if (isClientWorkspace(authUser)) {
                let program = location.state?.program || location.state?.assessment || null;
                if (!program?.created_by_user_id) {
                    try {
                        const res = await getInsiderProgramService(code);
                        program = res?.data?.learning_program || program;
                    } catch (_) { /* invokeApi surfaces the error */ }
                }
                viewOnly = !!program?.created_by_user_id
                    && String(program.created_by_user_id) !== String(authUser?._id);
            }
            if (cancelled) return;
            history.replace({
                pathname: '/dq_pro/program/creation/preview',
                state: { programCode: code, viewOnly },
            });
        };

        open();
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [code]);

    return <LoaderWithBackDrop loading={true} />;
};

export default DQProProgPreviewRedirectPage;
